export const SUBMIT_USOB_CUSTOMERS_ACTION_REQUESTED =
  "SUBMIT_USOB_CUSTOMERS_ACTION_REQUESTED";
export const SUBMIT_USOB_CUSTOMERS_ACTION_DISPATCHER =
  "SUBMIT_USOB_CUSTOMERS_ACTION_DISPATCHER";
export const SUBMIT_USOB_CUSTOMERS_ERROR_DISPATCHER =
  "SUBMIT_USOB_CUSTOMERS_ERROR_DISPATCHER";
export const USOB_CUSTOMERS_LOADING = "USOB_CUSTOMERS_LOADING";

//Action Creator
export const submitUSOBCustomersAction = (data) => ({
  type: SUBMIT_USOB_CUSTOMERS_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitUSOBCustomersActionDispatcher = (data) => ({
  type: SUBMIT_USOB_CUSTOMERS_ACTION_DISPATCHER,
  payload: data,
});

export const submitUSOBCustomersErrorDispatcher = (data) => ({
  type: SUBMIT_USOB_CUSTOMERS_ERROR_DISPATCHER,
  payload: data,
});

export const USOBCustomersLoading = (loading) => ({
  type: USOB_CUSTOMERS_LOADING,
  payload: loading,
});
